import styled from 'styled-components';
import media from 'styled-media-query';
import { Chip } from '../../../atoms/Chip';

interface LpAdProgramSlideProps {
  image: string;
  title: string;
  comment: string;
  tags: string[];
}

export const LpAdProgramSlide: React.FC<LpAdProgramSlideProps> = ({ image, title, comment, tags }) => {
  return (
    <Container>
      <Thumb src={image} />
      <Title>{title}</Title>
      <Comment>{comment}</Comment>
      <Tags>
        {tags.map((item) => {
          return <Chip key={item}>{item}</Chip>;
        })}
      </Tags>
    </Container>
  );
};

const Container = styled.div`
  overflow: hidden;
`;
const Thumb = styled.img`
  width: 100%;
  height: auto;
`;
const Title = styled.h3`
  margin-top: 1.5rem;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.125;

  ${media.lessThan('medium')`
    margin-top: 1rem;
  `}
`;
const Comment = styled.p`
  margin-top: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.6;
`;
const Tags = styled.p`
  margin-top: 1rem;
  font-size: 0;
`;
